exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".variations-header[data-v-557b4e60]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.variations-header .el-dialog__title[data-v-557b4e60]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;width:0;min-width:0;margin-right:15px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.variations-header .el-radio-group[data-v-557b4e60]{-ms-flex-negative:0;flex-shrink:0}.variations-table td[data-v-557b4e60],.variations-table th[data-v-557b4e60]{padding:.6rem 1rem;vertical-align:middle}.variations-table .variations-group td[data-v-557b4e60]{background-color:#f5f7fa}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-557b4e60","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/tenant/pos/partials/variations.vue
// module id = R+H+
// module chunks = 0